import { Component,  ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectionType, DatatableComponent } from '@swimlane/ngx-datatable';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ToastrService } from 'ngx-toastr';
import { InfoMessage} from 'src/app/shared/all-routes';
import { HttpService } from 'src/app/shared/http.service';
@Component({
  selector: 'app-broker',
  templateUrl: './broker.component.html',
})
export class BrokerComponent {
  selectionType = SelectionType;
  api: string = 'GetBrokerDataTableRows';
  data: any = {};
  columns = [];
  selectedRow: any = {};
  updatedRows: any[] = [];
  queryParams: any = {};
  rows: any[] = [];
  selected: any = [];
  originalData: any[] = [];
  tempRows: any[] = [];
  count: any;
  currentVisible: number = 5;
  appInfo: any = {};
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(DatatableComponent) pbTable: DatatableComponent | any;
  tableOptions: any = {
    HeaderHeight: '50',
    FooterHeight: '50',
    Limit: '4',
    ColumnMode: 'force',
    RowHeight: 'auto',
  };

  constructor(private httpService: HttpService,
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    let that = this;
    that.appInfo = this.httpService.getAppInfo(-9985);
    that.queryParams = that.route.snapshot.queryParams;
    that.get();
  }
  //api functions

  get() {
    let that = this;
    that.httpService.get(that.api).subscribe((res: any) => {
      that.rows = res.Rows;
      that.tempRows = res.Rows;
    });
  }

  updateFilter(event: any) {
    let that = this;
    const val = event.target.value.toLowerCase();
    that.rows = that.tempRows.filter((row:any) => {
      const searchableFields = [
        'BrokerNumber',
        'BrokerPseudonym',
        'BrokerName',
      ];
      return searchableFields.some(field => row[field]?.toString().toLowerCase().includes(val));
    });
    that.rows = [...that.rows];
    that.pbTable.offset = 0;
  }

  getRowClass(row: any): string {
    if (row.isSelected) {
      return 'row-color';
    } else {
      return '';
    }
  }
  checkboxRowSelect(rowData: any) {
    if (rowData.isSelected) {
      this.selectRow(rowData);
    } else {
      this.rows.forEach((data: any) => data.isSelected = false);
      this.selectedRow = null;
      this.rows = [...this.rows];
    }
  }
  select() {
    let that = this;
    let selectedData = that.selectedRow;
    selectedData.BrokerId ? that.activeModal.close(selectedData) : that.toastr.warning(InfoMessage.SelectMessage, "Warning!");
  }

  close() {
    let that = this;
    that.activeModal.close();
  }
  onRowActivate(event: any) {
  if (event.type === 'click') {
    this.selectRow(event.row);
  }
  }
  selectRow(rowData: any) {
  const isAlreadySelected = this.selectedRow?.BrokerId === rowData.BrokerId;

  if (isAlreadySelected) {
    this.rows.forEach((data: any) => {
      data.isSelected = false;
    });
    this.selectedRow = null;
  } else {
    this.rows.forEach((data: any) => {
      data.isSelected = data.BrokerId === rowData.BrokerId;
    });
    this.selectedRow = rowData;
  }

  this.rows = [...this.rows];
}
}
